// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon-icon-574e path{fill:currentColor}.Icon-primary-574e{color:var(--ui-primary-color)}.Icon-secondary-574e{color:var(--ui-text-color-secondary)}.Icon-tertiary-574e{color:var(--ui-text-color-tertiary)}.Icon-error-574e{color:var(--ui-text-color-error)}`, "",{"version":3,"sources":["webpack://./src/icon/Icon.module.scss"],"names":[],"mappings":"AAAA,qBACE,iBAAA,CAGF,mBACE,6BAAA,CAGF,qBACE,oCAAA,CAGF,oBACE,mCAAA,CAGF,iBACE,gCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Icon-icon-574e`,
	"primary": `Icon-primary-574e`,
	"secondary": `Icon-secondary-574e`,
	"tertiary": `Icon-tertiary-574e`,
	"error": `Icon-error-574e`
};
module.exports = ___CSS_LOADER_EXPORT___;
